import { s as e } from "../index.esm-DOxVcNnO.js";
import { styled as o } from "styled-components";
import { compose as n, border as t, color as p, flexbox as a, layout as c, position as d, space as l, typography as b, system as m } from "styled-system";
const i = n(t, p, a, c, d, l, b), r = /* @__PURE__ */ o("div").withConfig({
  shouldForwardProp: (s) => e(s)
}).withConfig({
  componentId: "sc-bbabca7d-0"
})([
  "",
  " box-sizing:border-box;margin:0;min-width:0;",
  ""
], m({
  gap: {
    property: "gap",
    scale: "space"
  }
}), i), h = /* @__PURE__ */ o(r).withConfig({
  componentId: "sc-bbabca7d-1"
})([
  "display:flex;",
  ""
], i), y = /* @__PURE__ */ o(r).withConfig({
  componentId: "sc-bbabca7d-2"
})([
  "display:inline-flex;",
  ""
], i);
export {
  r as Box,
  h as Flex,
  y as InlineFlex,
  i as flexModifiers
};
